import React from 'react';

const Image = ({ className, fileSmall, fileLong, fileAlt }) => {
  return (
    <div className={className}>
      <div className="paragraph--type--windmill-data__media">
        <picture>
          <source srcSet={fileSmall} media="screen and (max-width: 767px)" type="image/jpeg" />
          <source srcSet={fileLong} media="screen and (min-width: 768px) and (max-width: 991px)" type="image/jpeg" />
          <source srcSet={fileLong} media="screen and (min-width: 992px) and (max-width: 1199px)" type="image/jpeg" />
          <source srcSet={fileLong} media="screen and (min-width: 1200px)" type="image/jpeg" />
          <img src={fileLong} alt={fileAlt} />
        </picture>
      </div>
    </div>
  );
};

export default Image;
